module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av774-f096fba286c95fdc381bf820a7f23f68.jpg";